import { render } from "./AddMusicDialog.vue?vue&type=template&id=2e1b2d97&scoped=true&ts=true"
import script from "./AddMusicDialog.vue?vue&type=script&lang=ts"
export * from "./AddMusicDialog.vue?vue&type=script&lang=ts"

import "./AddMusicDialog.vue?vue&type=style&index=0&id=2e1b2d97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e1b2d97"]])

export default __exports__